<template>
  <div class="p-3 bg-white">
    <shared-auto-call-system-export-data
      @exportSuccess="closePopup"
    ></shared-auto-call-system-export-data>

    <div class="text-center">
      <vs-button id="exportButton" class="m-2" color="primary" type="filled" @click.prevent="submitExport">{{ $t('export') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="closePopup">{{ $t('cancel') }}</vs-button>
    </div>

  </div>
</template>

<script>
import SharedAutoCallSystemExportData from '@/views/Shared/AutoCallSystem/ExportData'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Window.AutoCallSystem.ExportData',
  components: {
    SharedAutoCallSystemExportData
  },
  methods: {
    submitExport () {
      EventBus.$emit('initExportAutoCallSystemData')
    },
    closePopup () {
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
